"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UsernameRestrictionsPanelHeader = exports.UsernameRestrictionsPanelBody = void 0;

var _preact = require("preact");

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _Switcher = _interopRequireDefault(require("../../preact-components/control/Switcher"));

var _Textarea = _interopRequireDefault(require("../ui-components/Textarea"));

var _PanelItems = require("./PanelItems");

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

var _Message = require("../ui-components/Message");

var _ExternalLink = require("../ui-components/ExternalLink");

var _PanelHeaderWithIcon = require("../ui-components/PanelHeaderWithIcon");

var UsernameRestrictionsPanelBody = function UsernameRestrictionsPanelBody(_ref) {
  var isRestrictPhoneNumberAsUsernameEnabled = _ref.isRestrictPhoneNumberAsUsernameEnabled,
      isRestrictWordsInUsernameEnabled = _ref.isRestrictWordsInUsernameEnabled,
      restrictedWords = _ref.restrictedWords,
      showUsernameRestrictionsActionButtons = _ref.showUsernameRestrictionsActionButtons,
      showValidationError = _ref.showValidationError,
      _onSave = _ref.onSave,
      _onCancel = _ref.onCancel,
      _onTextareaFocus = _ref.onTextareaFocus,
      onRestrictPhoneNumberAsUsernameSettingChanged = _ref.onRestrictPhoneNumberAsUsernameSettingChanged,
      onRestrictWordsInUsernameSettingChanged = _ref.onRestrictWordsInUsernameSettingChanged,
      onRestrictedWordsChanged = _ref.onRestrictedWordsChanged;
  return (0, _preact.h)("div", {
    className: "panel-body-container"
  }, (0, _preact.h)(_Message.Message, {
    text: "Moderators can always change a username in Control (e.g. if you want to add your company name to an employee's username)."
  }), (0, _preact.h)("div", null, (0, _preact.h)(_Switcher.default, {
    on: isRestrictPhoneNumberAsUsernameEnabled,
    customClass: "panel-switch",
    label: "Block registrations with phone numbers as usernames.",
    onChange: function onChange() {
      return onRestrictPhoneNumberAsUsernameSettingChanged(!isRestrictPhoneNumberAsUsernameEnabled);
    }
  })), (0, _preact.h)(_ExternalLink.ExternalLink, {
    label: "How do we block phone numbers",
    url: "https://communities.gainsight.com/moderating-users-61/restrict-users-from-using-a-phone-number-specific-keywords-in-their-username-19167?tid=19167&fid=61"
  }), (0, _preact.h)("div", {
    className: "panel-switch-textarea-container"
  }, (0, _preact.h)("div", {
    className: "switch-icon-container"
  }, (0, _preact.h)(_Switcher.default, {
    on: isRestrictWordsInUsernameEnabled,
    customClass: "panel-switch",
    label: "Block registrations where username contains any of the following keywords (separated keywords by comma, e.g. moderator, staff).",
    onChange: function onChange() {
      return onRestrictWordsInUsernameSettingChanged(!isRestrictWordsInUsernameEnabled);
    }
  }), (0, _preact.h)(_Tooltip.default, {
    withArrow: true,
    position: "right",
    trigger: (0, _preact.h)(_assets.default, {
      customClass: "icon-help",
      icon: "help"
    }),
    customClasses: "panel-help-tooltip tooltip-message--right",
    tooltipMessage: "This filter matches based on a simple contains rule (e.g. all the following will match on the keyword 'inSided': 'INSIDED', 'inSided123','xinSidedx', 'inSided Fan'"
  })), (0, _preact.h)("div", {
    className: "panel-textarea-container"
  }, (0, _preact.h)(_Textarea.default, {
    value: restrictedWords === null || restrictedWords === void 0 ? void 0 : restrictedWords.join(', '),
    disabled: !isRestrictWordsInUsernameEnabled,
    newStyle: true,
    adjustHeight: false,
    placeholder: "Add keywords...",
    onTextareaFocus: function onTextareaFocus() {
      return _onTextareaFocus();
    },
    onContentChange: function onContentChange(value) {
      return onRestrictedWordsChanged(value.trim());
    },
    class: "panel-text-area ".concat(showValidationError ? 'panel-text-area-error' : '', " ")
  }), showValidationError && (0, _preact.h)("div", {
    className: "error-message-container"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_assets.default, {
    customClass: "icon-warning",
    icon: "warning"
  })), (0, _preact.h)("div", {
    className: "error-message"
  }, "Please fill in the required field")))), showUsernameRestrictionsActionButtons && (0, _preact.h)(_PanelItems.ActionButtons, {
    onSave: function onSave() {
      return _onSave();
    },
    onCancel: function onCancel() {
      return _onCancel();
    }
  }));
};

exports.UsernameRestrictionsPanelBody = UsernameRestrictionsPanelBody;

var UsernameRestrictionsPanelHeader = function UsernameRestrictionsPanelHeader(_ref2) {
  var statusText = _ref2.statusText;
  return (0, _preact.h)(_PanelHeaderWithIcon.PanelHeaderWithIcon, {
    customClass: "panel-header-container",
    iconCustomClass: "icon-panel-header",
    icon: "usernameRestrictions",
    title: "Username restrictions",
    statusText: statusText
  });
};

exports.UsernameRestrictionsPanelHeader = UsernameRestrictionsPanelHeader;